// Helpers the floating-formula line and banner share (ledger row 132).
//
// Row 138 (Chris 2026-09-21, "this is Phils area"): no stage move waits for a
// floating formula any more, so the enquiry's gate mirror that lived here is
// gone. The hedging desk sets every formula from its task; the server says per
// side who may edit (``can_edit``).

// Product 1 is the enquiry's first product row, or the enquiry itself when it
// has no rows (a legacy single-product enquiry, matched by product_id null).
export const productOneIdOf = (enquiry) => (
  Array.isArray(enquiry?.products) && enquiry.products.length > 0
    ? (enquiry.products[0].id ?? null)
    : null
);

// The form's product lines in the order the server numbers them: Product 1
// is the inline fields, Product 2.. are ``extra_products``.
export const formProductLines = (formState) => [
  { index: 0, number: 1, row: formState, isProductOne: true },
  ...(Array.isArray(formState?.extra_products) ? formState.extra_products : [])
    .map((row, idx) => ({ index: idx + 1, number: idx + 2, row, isProductOne: false })),
];

export const findFormulaLine = (data, productId) => (
  (Array.isArray(data?.lines) ? data.lines : [])
    .find((line) => (line.product_id ?? null) === (productId ?? null)) || null
);

export const PRICING_TYPE_FIELD = { sell: 'pricing_type', buy: 'supplier_pricing_type' };
